export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  LOCATION: 'location',
};
